import script from "./SettingsAccountSection.vue?vue&type=script&setup=true&lang=js"
export * from "./SettingsAccountSection.vue?vue&type=script&setup=true&lang=js"

import "./SettingsAccountSection.vue?vue&type=style&index=0&id=20faaec6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20faaec6"]])

export default __exports__